import { render, staticRenderFns } from "./SwContainer.vue?vue&type=template&id=2e58dcfa"
import script from "./SwContainer.vue?vue&type=script&lang=js"
export * from "./SwContainer.vue?vue&type=script&lang=js"
import style0 from "./SwContainer.vue?vue&type=style&index=0&id=2e58dcfa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports